import moment from "moment";

import DateConstants from "#app/shared/lib/dates/DateConstants";

export class TaskDTO {
    public readonly comment: string;
    public readonly contact_id: number | null;
    public readonly custom_task_id: number | null;
    public readonly end_at: string;
    public readonly end_at_datetime: string;
    public readonly id: number | null;
    public readonly is_done: boolean;
    public readonly responsible_user_id: number | null;
    public readonly start_at: string;
    public readonly type_id: number;
    public readonly user_id: number | null;

    constructor(data: {
        comment: string;
        contact_id: number | null;
        custom_task_id: number | null;
        end_at: string;
        end_at_datetime: string;
        id: number | null;
        is_done: boolean;
        responsible_user_id: number | null;
        start_at: string;
        type_id: number;
        user_id: number | null;
    }) {
        this.comment = data.comment;
        this.contact_id = data.contact_id;
        this.custom_task_id = data.custom_task_id;
        this.end_at = data.end_at;
        this.end_at_datetime = data.end_at_datetime;
        this.id = data.id;
        this.is_done = data.is_done;
        this.responsible_user_id = data.responsible_user_id;
        this.start_at = data.start_at;
        this.type_id = data.type_id;
        this.user_id = data.user_id;
    }

    public static create(
        comment: string,
        date: moment.Moment,
        userData: { id: number } | null,
        type: number
    ): TaskDTO {
        const formattedDate = date.format(DateConstants.dateTimeUserFormat);
        return new TaskDTO({
            comment,
            contact_id: null,
            custom_task_id: null,
            end_at: formattedDate,
            end_at_datetime: formattedDate,
            id: null,
            is_done: true,
            responsible_user_id: userData?.id || null,
            start_at: formattedDate,
            type_id: type,
            user_id: null,
        });
    }

    public static fromRaw(raw: Record<string, any>): TaskDTO {
        return new TaskDTO({
            comment: String(raw.comment ?? ""),
            contact_id: typeof raw.contact_id === "number" ? raw.contact_id : null,
            custom_task_id: typeof raw.custom_task_id === "number" ? raw.custom_task_id : null,
            end_at: String(raw.end_at ?? ""),
            end_at_datetime: String(raw.end_at_datetime ?? raw.end_at ?? ""),
            id: typeof raw.id === "number" ? raw.id : null,
            is_done: Boolean(raw.is_done),
            responsible_user_id:
                typeof raw.responsible_user_id === "number" ? raw.responsible_user_id : null,
            start_at: String(raw.start_at ?? ""),
            type_id: typeof raw.type_id === "number" ? raw.type_id : 0,
            user_id: typeof raw.user_id === "number" ? raw.user_id : null,
        });
    }

    public toJSON(): {
        comment: string;
        contact_id: number | null;
        custom_task_id: number | null;
        end_at: string;
        end_at_datetime: string;
        id: number | null;
        is_done: boolean;
        responsible_user_id: number | null;
        start_at: string;
        type_id: number;
        user_id: number | null;
    } {
        return {
            comment: this.comment,
            contact_id: this.contact_id,
            custom_task_id: this.custom_task_id,
            end_at: this.end_at,
            end_at_datetime: this.end_at_datetime,
            id: this.id,
            is_done: this.is_done,
            responsible_user_id: this.responsible_user_id,
            start_at: this.start_at,
            type_id: this.type_id,
            user_id: this.user_id,
        };
    }
}
